// extracted by mini-css-extract-plugin
export var active = "_2d-a";
export var activeIndicator = "_2d-8";
export var animate = "_2d-9";
export var disabled = "_2d-b";
export var fullWidth = "_2d-2";
export var lg = "_2d-7";
export var md = "_2d-6";
export var redoButtonTabGroup = "_2d-0";
export var sm = "_2d-5";
export var tabButton = "_2d-3";
export var tabButtonsContainer = "_2d-1";
export var xs = "_2d-4";